import { Component, computed, input, Signal } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { IconName, provideIcons } from '@ng-icons/core';
import { lucideArrowLeft, lucideMapPinHouse, lucideNotebookTabs } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmSidebarImports } from '@spartan-ng/helm/sidebar';

import { Cartographie } from '../../cartographie/models/cartographie.model';

@Component({
  selector: 'app-offre-regionale-layout',
  imports: [RouterOutlet, HlmSidebarImports, HlmIconImports, RouterModule, HlmButtonImports],
  templateUrl: './offre-regionale-layout.component.html',
  providers: [
    provideIcons({
      lucideNotebookTabs,
      lucideMapPinHouse,
      lucideArrowLeft,
    }),
  ],
})
export class OffreRegionaleLayoutComponent {
  readonly cartographie = input.required<Cartographie>();

  protected readonly _items: Signal<{ title: string; url: string; icon: IconName }[]> = computed(() => [
    {
      title: 'Catalogue national',
      url: `/cartographies/${this.cartographie().slug}/catalogue-national`,
      icon: 'lucideNotebookTabs',
    },
    {
      title: 'Offre régionale',
      url: `/cartographies/${this.cartographie().slug}/offre-régionale`,
      icon: 'lucideMapPinHouse',
    },
  ]);
}
